import { render, staticRenderFns } from "./XimuDialog.vue?vue&type=template&id=201cd4b8&scoped=true"
import script from "./XimuDialog.vue?vue&type=script&lang=js"
export * from "./XimuDialog.vue?vue&type=script&lang=js"
import style0 from "./XimuDialog.vue?vue&type=style&index=0&id=201cd4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201cd4b8",
  null
  
)

export default component.exports